<template>
  <div>
    <app-tracking></app-tracking>
  </div>
</template>
<script>

import Amenity from "@/mixins/Amenity";
import Tracking from "@/components/journey/Tracking";

export default {
  name: 'amenity',
  mixins: [],
  data() {
    return {
      poi: null,
      markers: [
        'transport', 'health', 'education', 'outdoor', 'food', 'shopping', 'childcare'
      ]
    }
  },
  components: {
    'app-tracking': Tracking
  },
  watch: {
    poi: function (val, oldval) {
      if (val) {
        this.$store.commit("setActivePoi", this.markers)
      }
    }
  },
  mounted() {
    this.poi = this.$store.getters.getPoi;
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setPoi') {
        this.poi = state.amenityStore.poi;
      }
    })
  },
  methods: {}
}
</script>




// WEBPACK FOOTER //
// src/components/amenities/Amenity.vue